import { Component, OnInit, Renderer2, Inject } from "@angular/core";
import { DOCUMENT } from "@angular/common";

@Component({
  selector: "app-user-survey",
  templateUrl: "./user-survey.component.html",
  styleUrls: ["./user-survey.component.scss"],
  standalone: true,
})
export class UserSurveyComponent implements OnInit {
  constructor(
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit(): void {
    // Create and append the Typeform script
    const script = this.renderer.createElement('script');
    script.src = '//embed.typeform.com/next/embed.js';
    script.async = true;
    this.renderer.appendChild(this.document.body, script);
  }

  ngOnDestroy(): void {
    // Remove the script when component is destroyed
    const script = this.document.querySelector('script[src="//embed.typeform.com/next/embed.js"]');
    if (script) {
      this.renderer.removeChild(this.document.body, script);
    }
  }
} 